import { TALENTQ_STORE_NAMES } from './constants';
import binding from './binding';
import account from './account';
import account_list from './account_list';
import project from './project';
import project_list from './project_list';
import project_form from './project_form';
import dictionary_assessment from './dictionaries/assessment';
import dictionary_norm_groups from './dictionaries/norm_groups';
import dictionary_pdf_report_options from './dictionaries/pdf_report_options';
import dictionary_pdf_report_types from './dictionaries/pdf_report_types';
import dictionary_report_options from './dictionaries/report_options';
import dictionary_report_scales from './dictionaries/report_scales';

export default {
  namespaced: true,
  modules: {
    [TALENTQ_STORE_NAMES.BINDING]: binding,
    [TALENTQ_STORE_NAMES.ACCOUNT]: account,
    [TALENTQ_STORE_NAMES.ACCOUNT_LIST]: account_list,
    [TALENTQ_STORE_NAMES.PROJECT]: project,
    [TALENTQ_STORE_NAMES.PROJECT_LIST]: project_list,
    [TALENTQ_STORE_NAMES.PROJECT_FORM]: project_form,
    [TALENTQ_STORE_NAMES.DICTIONARY_ASSESSMENT]: dictionary_assessment,
    [TALENTQ_STORE_NAMES.DICTIONARY_NORM_GROUPS]: dictionary_norm_groups,
    [TALENTQ_STORE_NAMES.DICTIONARY_PDF_REPORT_OPTIONS]: dictionary_pdf_report_options,
    [TALENTQ_STORE_NAMES.DICTIONARY_PDF_REPORT_TYPES]: dictionary_pdf_report_types,
    [TALENTQ_STORE_NAMES.DICTIONARY_REPORT_OPTIONS]: dictionary_report_options,
    [TALENTQ_STORE_NAMES.DICTIONARY_REPORT_SCALES]: dictionary_report_scales
  }
};
